export const dataUtils = {
    methods: {
        formatLargeNumber(number) {
            if (number >= 1000000000) {
                return (
                    (number / 1000000000).toFixed(1).replace(/\.0$/, '') + 'B'
                ); // Billion
            } else if (number >= 1000000) {
                return (number / 1000000).toFixed(1).replace(/\.0$/, '') + 'M'; // Million
            } else if (number >= 1000) {
                return (number / 1000).toFixed(1).replace(/\.0$/, '') + 'k'; // Thousand
            } else {
                return number.toString(); // Less than 1,000, return as is
            }
        },

        formatNumber(number) {
            //Add commas to number
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        parseString(string) {
            if (!string) {
                return '0';
            }
            return string.toString();
        }
    }
};
